// How it works, step 4 "Get Paid" (1.5.2 get-paid-r2, option A1): $150.00
// lands on the red DEBIT card, the card dips, a green ring and a tick
// answer, on a 4.8s loop. Under it the gold INSTANT chip, when it arrives
// ("within 30 minutes": Stripe's instant payouts usually land well inside
// that, never promise "instantly") and when it unlocks. Styles in
// GetPaidDemo.css; Reduce Motion swaps every movement for a fade.
import React from "react";
import { t } from "../../i18n";
import { PARTNER } from "../home/HomeGlobe";
import "./GetPaidDemo.css";

const GetPaidDemo: React.FC = () => (
  <div className="payout-card gp-card">
    <div className="gp-stage" aria-hidden="true">
      <span className="gp-glow" />
      <div className="gp-card-wrap">
        <div className="gp-debit">
          <span className="gp-debit-sheen" />
          <span className="gp-debit-blob" />
          <span className="gp-debit-chip" />
          <svg className="gp-debit-nfc" width="16" height="20" viewBox="0 0 16 20">
            <path d="M2 3q4 7 0 14M6.5 1.5q5 8.5 0 17M11 0q6 10 0 20" fill="none" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" opacity=".9" />
          </svg>
          <span className="gp-debit-bolt">
            <svg width="15" height="15" viewBox="0 0 24 24">
              <path d="M13.2 2 5 13.4h5l-1.6 8.6L17 10.4h-5.2Z" fill="#E5383B" />
            </svg>
          </span>
          <span className="gp-debit-num">•••• 8024</span>
          <span className="gp-debit-word">{t("getPaidDemo.debit")}</span>
        </div>
        <span className="gp-ring" />
      </div>
      <span className="gp-drop">+$150.00</span>
      <span className="gp-tick">
        <svg width="16" height="16" viewBox="0 0 24 24">
          <path d="M5 12.5l4.5 4.5L19 7.5" fill="none" stroke="#fff" strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </span>
    </div>
    <div className="gp-foot">
      <span className="gp-instant">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <path d="M13.5 2 4.5 13.5H11L10 22l9-11.5h-6.5L13.5 2Z" />
        </svg>
        {t("getPaidDemo.instant")}
      </span>
      <span className="gp-eta">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" aria-hidden="true">
          <circle cx="12" cy="13" r="8" />
          <path d="M12 9v4l2.5 2M10 2h4" />
        </svg>
        {t("getPaidDemo.toYourDebitCard")}
      </span>
      <span className="gp-avail">{t("getPaidDemo.availableAfterFirstCashouts")}</span>
    </div>
    {/* Stripe's official white wordmark (partner logo rules), not the name in purple text. */}
    <div className="gp-powered">
      {t("getPaidDemo.poweredBy")}
      <img className="gp-powered-stripe" src="/stripe-wordmark-white.svg" alt={PARTNER.stripe} />
    </div>
  </div>
);

export default GetPaidDemo;
